import { createExportId, exportLockManager } from "../export/exportLock";

export function buildSaveLockKey(context) {
  const tool = context.toolId ?? "unknown";
  const contentKey = context.contentKey ?? context.saveId;
  return `save:${tool}:${contentKey}`;
}

export function createSaveId() {
  return createExportId();
}

export { exportLockManager as saveLockManager };
